import React, { useState, useEffect, createRef } from 'react';
import CustomTab from './CustomTab';
import { IComponentTab, IComponent } from '../../component';
import { alpha } from '../../utils/color';
import RootStore from "../../store/RootStore";
import { inject, observer } from "mobx-react";

const setCustom = function(props: IComponentTab) {
  const { mode = 'top', activeBg, activeOpacity, fontSize, isBold } = props;
  let customFontSize = 0;
  let customBold = false;
  let activeColor = '';
  if (mode === 'top') {
    customFontSize = fontSize || 16; // top默认值是16
    customBold = isBold || false;
  } else {
    activeColor = alpha(activeBg, (activeOpacity || 100) / 100);
  }
  return { customFontSize, customBold, activeColor };
};

// TODO: 需要将滑动事件隔离起来，不要在多个tab下触发

const AllForTab = (props: IComponentTab) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const { list, fixed, cid, mode = 'top' } = props;
  const { customFontSize, customBold, activeColor } = setCustom(props);

  const changeActiveIndex = (index: number) => {
    setActiveIndex(index);

    window.sessionStorage.setItem(`tab_${cid}`, `${index}`);

    let event = new Event('tab-index-change');
    event.data = index;
    event.cid = cid;

    window.dispatchEvent(event);
    setTimeout(() => {
      window.dispatchEvent(new Event(`custom-tab-height-change`));
      window.dispatchEvent(new Event(`resize`));
    }, 16);
  };

  const showPhotoPendant = () => {
    setTimeout(() => {
      let event = new Event('PENDENT_CHANGE');
      event.action = 'tab_has_photo';
      window.dispatchEvent(event);
    }, 320);
  };

  const hidePhotoPendant = () => {
    setTimeout(() => {
      let event = new Event('PENDENT_CHANGE');
      event.action = 'tab_no_photo';
      window.dispatchEvent(event);
    }, 320);
  };

  const checkPhoto = (index: number) => {
    if (list && list.length && list[index]) {
      let children = list[index]!.children as IComponent[];
      let exist = (children || []).find((it: IComponent) => {
        if (it && it.type == 'photo') {
          return true;
        }
        return false;
      });

      if (exist) {
        showPhotoPendant();
        // 有照片的情况下，没有触发lazyload的加载
        let scrollY = window.scrollY;
        window.scrollTo(0, scrollY + 1);
        window.scrollTo(0, scrollY);
        // window.dispatchEvent(new Event('scroll'));
      } else {
        hidePhotoPendant();
      }
    }
  };

  const showCommentEvent = () => {
    setTimeout(() => {
      let event = new Event('custom-tab-has-comment');
      window.dispatchEvent(event);
    }, 16);
  };

  const hideCommentEvent = () => {
    setTimeout(() => {
      let event = new Event('custom-tab-no-comment');
      window.dispatchEvent(event);
    }, 16);
  };

  const checkComment = (index: number) => {
    if (list && list.length && list[index]) {
      let children = list[index]!.children as IComponent[];
      let exist = (children || []).find((it: IComponent) => {
        // @ts-ignore
        if (it && it.type == 'commentlist' && it.theme == 'list') {
          return true;
        }
        return false;
      });

      if (exist) {
        showCommentEvent();
      } else {
        hideCommentEvent();
      }
    }
  };

  const {pagedataStore} = props.rootStore!;
  useEffect(() => {
    let tab = document.getElementById(`tab_${cid}`);
    if (tab) {
      let tabs = tab.querySelector('.tabs');

      if (tabs && tabs.scrollWidth > tabs.clientWidth) {
        let active = tabs.querySelector('.active');
        if (active) {
          // @ts-ignore
          let offsetLeft = active.offsetLeft;
          tabs.scrollLeft = Math.max(
            0,
            offsetLeft - tabs.clientWidth / 2 + active.clientWidth / 2
          );
        }
      }
    }
    // 此处主要是要检测那些具备无限加载功能的组件，要让他们自己去控制自己的滑动逻辑
    checkPhoto(activeIndex);
    if(pagedataStore.renderMode != 'pc') {
      checkComment(activeIndex);
    }
  }, [activeIndex, pagedataStore.renderMode]);

  // 检测一下是否有最后一次的tab记录
  useEffect(()=>{
    let record = window.sessionStorage.getItem(`tab_${cid}`);
    if(record && record.length) {
      let index = Number(record);
      if(list && index < list.length) {
        console.log(`重新设置tab index`, `tab_${cid}`, index);
        setActiveIndex(index);
      }
    }
  }, []);

  // 添加一个全局事件，主要是让自定义代码可以切换tab内容
  useEffect(() => {
    const customTabIndex = (e: any) => {
      if (e) {
        let { data } = e;
        if (data) {
          changeActiveIndex(Number(data));
        }
      }
    };
    window.addEventListener('custom-tab-index', customTabIndex);

    return () => {
      window.removeEventListener('custom-tab-index', customTabIndex);
    };
  }, []);

  return (
    <div id={`tab_${cid}`}>
      <CustomTab
        fixed={fixed}
        tabs={list}
        mode={mode}
        activeIndex={activeIndex}
        onClick={(index: number) => changeActiveIndex(index)}
        activeColor={activeColor}
        fontSize={customFontSize}
        isBold={customBold}
      />
    </div>
  );
};

export default inject("rootStore")(observer(AllForTab));
